/**
 * Permission utility functions.
 *
 * These are pure functions that work with any permissions array.
 * For component-level checks use the usePermission() hook in @features/roles.
 */

export function hasPermission(userPermissions, permission) {
  if (!Array.isArray(userPermissions) || !permission) return false
  return userPermissions.includes(permission)
}

export function hasAnyPermission(userPermissions, permissions) {
  if (!Array.isArray(userPermissions) || !Array.isArray(permissions)) return false
  return permissions.some((p) => userPermissions.includes(p))
}

export function hasAllPermissions(userPermissions, permissions) {
  if (!Array.isArray(userPermissions) || !Array.isArray(permissions)) return false
  return permissions.every((p) => userPermissions.includes(p))
}

/**
 * canAccessRoute — checks whether a user may navigate to a route.
 * @param {string[]} userPermissions
 * @param {string | string[] | undefined} routePermission  undefined = no restriction
 */
export function canAccessRoute(userPermissions, routePermission) {
  if (!routePermission) return true
  if (!Array.isArray(userPermissions)) return false
  if (typeof routePermission === 'string') return hasPermission(userPermissions, routePermission)
  if (Array.isArray(routePermission))     return hasAnyPermission(userPermissions, routePermission)
  return false
}
